const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardiology(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M10.179,7.237l-1.7,2.5c0,0,1.5,1.1,0.1,4.2 s-0.7,6.2,1.1,9c0,0,4,5.7,9.9,4.8c0,0,3.6-0.6,3.4-8.7c0,0,0.3-8.4-6.1-9.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M11.874,13.433c0,0-2.795-2.396-0.895-5.696 l-1.3-1l0.8-1.3l1.3,1l0.8-0.8l-0.7-1.4l1.4-0.6l0.6,1.4h1.1l0.4-1.4l1.4,0.3l-0.5,1.5c0,0,0.4,0.2,0.6,0.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    points: "4.379,20.837 8.779,20.837  10.679,17.637 12.579,23.037 13.779,20.937 18.079,20.937 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.687,
    y: 21.342,
    transform: "matrix(0.8124 -0.5831 0.5831 0.8124 -9.333 17.3765)",
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    width: 1.3,
    height: 3.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.179,
    cy: 20.037,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 20.179,
    cy: 20.037,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5BA5ED",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M21.879,24.137l3.3,4.6 c0.3,0.4,0.9,0.5,1.3,0.2c0.4-0.3,0.5-0.9,0.2-1.3l-3.3-4.6L21.879,24.137z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2C355E"
    },
    points: "21.879,19.337 20.879,19.337 20.879,18.337 19.479,18.337 19.479,19.337 18.479,19.337  18.479,20.737 19.479,20.737 19.479,21.737 20.879,21.737 20.879,20.737 21.879,20.737 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB3BC",
      stroke: "#2C355E",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M9.647,14.392c0,0,2.416,0.343,2.771-2.25 c0,0,0.71-6.158,6.371-6.205c0,0,1.421-0.024,2.842,0.805l-1.16,3.008c0,0-1.918-1.066-3.466,0.055 c-1.547,1.121-1.532,4.674,0.237,6.126"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardiology);
export default __webpack_public_path__ + "static/media/cardiology.b2d4530d62435dedeb5c4bfb02f4ed55.svg";
export { ForwardRef as ReactComponent };